import { render, staticRenderFns } from "./SalesRecapDetails.vue?vue&type=template&id=704a6322&"
import script from "./SalesRecapDetails.vue?vue&type=script&lang=js&"
export * from "./SalesRecapDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports